import request from "@/utils/request.js";
// 获取房屋管理列表
export const houseList = data => {
  return request({
    url: "/api/hz-smart-community/house/info/list",
    params: data || {}
  });
};
// 获取区域列表
export const leftListquery = data => {
  return request({
    url: "/api/hz-smart-community/region/info/list",
    params: data || {}
  });
};
// 获取单位信息列表
export const unitList = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/list",
    params: data
  });
};
// 车辆人员列表
export const carlist = data => {
  return request({
    url: "/api/hz-smart-community/car/info/list",
    params: data || {}
  });
};
// 档案统计
export const archiveslist = data => {
  return request({
    url: "/api/hz-smart-community/archives/manage/count",
    params: data || {}
  });
};

// 单位信息
export const infoQuery = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/info/" + data,
    params: data || {}
  });
};
// 获取具体区域
export const infoByPoint = data => {
  return request({
    url: "/api/hz-smart-community/region/info/infoByPoint",
    params: data || {}
  });
}


// 根据从业人员id查询--信息
export const cyryxxInfo = data => {
  return request({
    url: "/apiData/hz-data-community/cyryxx/info/select",
    params: data || {}
  });
}